import React from "react";
import "./Main.css";
import Pop from "../News/Pop";
import { useParams } from "react-router-dom";

export const videoData = [
  {
    id: 1,
    title: "O'zbekistan",
    dataTime: "02.09.2022",
    img: "https://www.youtube.com/embed/XH1aXNIpK4s",
    desk: "Фарғона водийсида илк бор ягона корпоратив бошқарув, ягона стратегия, ягона кузатув кенгашига қаратилган бизнес тармоқлари MARAFON номи остида бирлашди.",
  },
  {
    id: 2,
    title: "O'zbekistan",
    dataTime: "02.09.2022",
    img: "https://www.youtube.com/embed/XH1aXNIpK4s",
    desk: "Фарғона водийсида илк бор ягона корпоратив бошқарув, ягона стратегия, ягона кузатув кенгашига қаратилган бизнес тармоқлари MARAFON номи остида бирлашди.",
  },
];

export default function VideoPage() {
    const { id } = useParams()
   

  return (
    <>
      <main className="containers">
        <div className="row video_page">
          <div className="col-md-9">
            <div className="video_main">
              <iframe
                src="https://www.youtube.com/embed/XH1aXNIpK4s"
                title="Bootstrapda website yasash"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                controls
              ></iframe>
               <div className="video_main_text py-4">
               <h3>Video News</h3>
               </div>
            </div>
            <div className="cart_news_video my-5 py-5">
              {videoData
                ? videoData.map((video) => (
                    <div key={video.id} className="card video_cart">
                      <iframe
                        height="600px"
                        src={video.img}
                        title="Bootstrapda website yasash"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                        controls
                      ></iframe>
                      <div className="card-body">
                        <p className="card-text">
                          {video.desk}
                        </p>
                        <hr />
                        <div className="cart_footer w-100 d-flex align-items-center justify-content-between">
                          <h4 className="text-success fs-6">{video.title} </h4>
                          <span>
                            {" "}
                            <i class="bi bi-clock me-2"></i> {video.dataTime}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))
                : ""}
            </div>
          </div>
          <Pop />
        </div>
        <h1 className="section-title my-4">
          «Ол ва кетавер». Amazon Лондонда касса ва сотувчиларсиз ишлайдиган
          дўкон очди
        </h1>
        <p className="news-info mt-15">
          Интернет савдоси гиганти Amazon Лондонда кассасиз ишлайдиган Amazon
          Fresh озиқ-овқат дўконини очди. Бу АҚШ сарҳадларидан ташқаридаги илк
          шундай дўкондир.
        </p>
        <iframe
          className="video_iframe"
          src="https://www.youtube.com/embed/XH1aXNIpK4s"
          title="Bootstrapda website yasash"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          controls
        ></iframe>
        <p className="info-img mt-15">Lorem, ipsum dolor.</p>
        <img src="" alt="" className="main-img mt-20" />
        <p className="info-img mt-15">Lorem, ipsum dolor.</p>
        <p className="news-info-small mt-15">
          «Бундай йўналиш Amazon’га етказиш ва қайтариш харажатларини
          қисқартиришга кўмак беради ва харидорлар бунга муносиб баҳо беришади»,
          дейди NBK Retail таҳлилчиси Натали Берг.
        </p>
        <p className="news-info-small mt-15">
          Бироқ харидларга янги ёндашув рақобатчиларга хавф туғдириши даргумон:
          асосий савдо тармоқларининг кассасиз ва сотувчисиз ишлаш бўйича ўз
          ишланмалари бор.
        </p>
        <p className="news-info-small mt-15">
          Умуман олганда, Amazon’нинг усули Marks and Spencer, Tesco ёки
          Sainsbury's каби анъанавий супермаркетлардаги каби ҳар бир товарни
          алоҳида сканлаш харидорларга бироз малол келадиган тизимдан кўра
          харидорлар учун анча жозибадор кўринади
        </p>
        <p className="news-info-small mt-15">
          АҚШ компанияси ўз технологияларидан кўнгли шу даражада тўқки,
          харидорларга улар нима сотиб олганларини тизим қандай таниб олиши
          борасида мутлақо хавотир олмасликлари кераклигини айтмоқда.
        </p>
        <iframe
          className="video_iframe"
          src="https://www.youtube.com/embed/XH1aXNIpK4s"
          title="Bootstrapda website yasash"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          controls
        ></iframe>
        <p className="info-img mt-15">Lorem, ipsum dolor.</p>
        <p className="news-info-small mt-15">
          Харидорлар дўконга кираверишда смартфондаги иловани скан қилишади,
          товарларни олиб саватга солишади ва уларга чиқаверишда автомат тарзда
          ҳисоб тақдим қилинади.
        </p>
        <p className="news-info-small mt-15">
          Харидорлар дўконга кираверишда смартфондаги иловани скан қилишади,
          товарларни олиб саватга солишади ва уларга чиқаверишда автомат тарзда
          ҳисоб тақдим қилинади.
        </p>
        <p className="news-info-small mt-15">
          Баъзи экспертлар бундай тизим бозордаги кучлар тақсимотини
          ўзгартиришига шубҳа билан қараётган бўлишса, бошқалари янги харид
          тизимини савдо соҳасидаги бурилиш нуқтаси деб ҳисоблашмоқда.
        </p>
        <iframe
         className="video_iframe"
          src="https://www.youtube.com/embed/XH1aXNIpK4s"
          title="Bootstrapda website yasash"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          controls
        ></iframe>
        <p className="info-img mt-15">Lorem, ipsum dolor.</p>
        <p className="news-info-small mt-15">
          Бироқ харидларга янги ёндашув рақобатчиларга хавф туғдириши даргумон:
          асосий савдо тармоқларининг кассасиз ва сотувчисиз ишлаш бўйича ўз
          ишланмалари бор.
        </p>
        <p className="news-info-small mt-15">
          Умуман олганда, Amazon’нинг усули Marks and Spencer, Tesco ёки
          Sainsbury's каби анъанавий супермаркетлардаги каби ҳар бир товарни
          алоҳида сканлаш харидорларга бироз малол келадиган тизимдан кўра
          харидорлар учун анча жозибадор кўринади.
        </p>
        <p className="news-info-small mt-15">
          АҚШ компанияси ўз технологияларидан кўнгли шу даражада тўқки,
          харидорларга улар нима сотиб олганларини тизим қандай таниб олиши
          борасида мутлақо хавотир олмасликлари кераклигини айтмоқда.
        </p>

        <p className="news-info-small mt-15">
          Умуман олганда, Amazon’нинг усули Marks and Spencer, Tesco ёки
          Sainsbury's каби анъанавий супермаркетлардаги каби ҳар бир товарни
          алоҳида сканлаш харидорларга бироз малол келадиган тизимдан кўра
          харидорлар учун анча жозибадор кўринади.
        </p>
        <p className="news-info-small mt-15">
          АҚШ компанияси ўз технологияларидан кўнгли шу даражада тўқки,
          харидорларга улар нима сотиб олганларини тизим қандай таниб олиши
          борасида мутлақо хавотир олмасликлари кераклигини айтмоқда.
        </p>
        <iframe
          className="video_iframe"
          src="https://www.youtube.com/embed/XH1aXNIpK4s"
          title="Bootstrapda website yasash"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          controls
        ></iframe>
        <p className="info-img mt-15">Lorem, ipsum dolor.</p>
        <p className="news-info-small mt-15">
          Умуман олганда, Amazon’нинг усули Marks and Spencer, Tesco ёки
          Sainsbury's каби анъанавий супермаркетлардаги каби ҳар бир товарни
          алоҳида сканлаш харидорларга бироз малол келадиган тизимдан кўра
          харидорлар учун анча жозибадор кўринади
        </p>
        <div className="author mt-15">
          <p className="news-info-small">Ғайбуллаева Зилола</p>
        </div>
        <div className="tags">
          <button className="btn-tags fs-6">#Biznes</button>
          <button className="btn-tags fs-6">#London</button>
          <button className="btn-tags fs-6">#Amozon</button>
        </div>
        <div className="theme">
          <div className="img-box"></div>
          <h1 className="news-title"> Мавзуга доир</h1>
        </div>
        {/* <Carousel /> */}
      </main>
    </>
  );
}
